import { uid } from '../../../../lib/uid';

/** One row of the Identified Development Needs grid, as the form holds it (levels as strings, as the cells do). */
export interface DraftNeed {
  /** Stable across renders, so removing a row keeps every other row's inputs in place. */
  key: string;
  /** Null for a row this form added. */
  id: string | null;
  competencyId: string;
  currentLevel: string;
  targetLevel: string;
  gap: string;
}

export function blankNeed(): DraftNeed {
  return { key: uid(), id: null, competencyId: '', currentLevel: '', targetLevel: '', gap: '' };
}

/** A row the server would drop — nothing chosen and nothing written. */
export function isBlankNeed(need: DraftNeed): boolean {
  return need.competencyId === '' && need.gap.trim() === '';
}

/** The first thing a non-blank row still needs, in the server's words — or null. */
export function needProblem(need: DraftNeed): string | null {
  if (isBlankNeed(need)) return null;
  if (!need.competencyId) return 'Choose a competency.';
  if (need.currentLevel === '') return 'Choose the current level.';
  if (need.targetLevel === '') return 'Choose the target level.';
  if (Number(need.targetLevel) < Number(need.currentLevel)) return 'The target is below the current level.';
  return null;
}
